export default "__VITE_ASSET__DvCxskE5__"